/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { CssHome } from "./css";
import { useTranslation } from "react-i18next";

// Logos
import SuvinilLogo from "../../assets/Images/Logos/suvinil.png";
import BasfLogo from "../../assets/Images/Logos/basf.png";
import SherwinLogo from "../../assets/Images/Logos/sherwin-Williams.png";
import EcomLogo from "../../assets/Images/Logos/ecom.png";
import EdpLogo from "../../assets/Images/Logos/edp.png";
import PeGLogo from "../../assets/Images/Logos/pg.png";
import DexcoLogo from "../../assets/Images/Logos/dexco.png";
import DuratexLogo from "../../assets/Images/Logos/duratexLogo.png";
import kevlarLogo from "../../assets/Images/Logos/kevlarLogo.png";
import MeioLogo from "../../assets/Images/Logos/meioMensagem.png";
import ArclinLogo from "../../assets/Images/Logos/arclinLogo.png";
import TicketLogo from "../../assets/Images/Logos/ticketSports.png";
import OxxoLogo from "../../assets/Images/Logos/oxxo.png";
import LbcaLogo from "../../assets/Images/Logos/lbca.png";
import ClubeDuratexLogo from "../../assets/Images/Logos/clubeDuratexLogo.png";
import DupontLogo from "../../assets/Images/Logos/dupont.png";
import TemLogo from "../../assets/Images/Logos/tem.png";
import MeuFinanciamentoLogo from "../../assets/Images/Logos/meuFinanciamento.png";
import SaintGobainLogo from "../../assets/Images/Logos/saintGobain.png";
import EvinoLogo from "../../assets/Images/Logos/evino.png";
import SrcomLogo from "../../assets/Images/Logos/srcomLogo.png";
import GrandCruLogo from "../../assets/Images/Logos/grandCru.png";
import FortalezaLogo from "../../assets/Images/Logos/fortalezaLogo.png";
import NeoLogo from "../../assets/Images/Logos/neo.png";
import Kpmg from "../../assets/Images/Logos/kpmg.png";
import Sicredi from "../../assets/Images/Logos/sicredi.png";
import Wake from "../../assets/Images/Logos/wake.png";
import Unico from "../../assets/Images/Logos/unico.png";


import Geo from "@/assets/Images/z-azul.png";

const Home = ({ scrollToId }) => {
  	const { t, i18n } = useTranslation();
	
	const [showBrandsTitle, setShowBrandsTitle] = useState(false);
	const brandsTitleRef = React.useRef(null);

	const brands = [
		{ src: SuvinilLogo, alt: "Suvinil", className: "logo-big" },
		{ src: SherwinLogo, alt: "Sherwin Willians", className: "logo-big" },		
		{ src: DexcoLogo, alt: "Dexco" },
		{ src: DuratexLogo, alt: "Duratex" },
		{ src: EcomLogo, alt: "Ecom", className: "logo-big" },
		{ src: PeGLogo, alt: "P&G", className: "logo-big" },
		
		{ src: MeioLogo, alt: "Meio & Mensagem" },
		{ src: OxxoLogo, alt: "Oxxo", className: "logo-big"},
		{ src: BasfLogo, alt: "Basf", className: "logo-big" },	
		{ src: Kpmg, alt: "Kpmg", className: "logo-big" },
		{ src: Sicredi, alt: "Sicredi", className: "logo-big" },	
		{ src: EdpLogo, alt: "EDP", className: "logo-big" },

		{ src: kevlarLogo, alt: "Kevlar" },
		{ src: ArclinLogo, alt: "Arclin" },		
		{ src: LbcaLogo, alt: "LBCA", className: "logo-extraLarge"},	
		{ src: ClubeDuratexLogo, alt: "Clube Duratex", className: "logo-big"},	
		{ src: DupontLogo, alt: "Dupont" },		
		{ src: MeuFinanciamentoLogo, alt: "Meu Financiamento",className: "logo-big" },	
			
		{ src: TemLogo, alt: "TEM",className: "logo-big" },
		{ src: TicketLogo, alt: "Ticket Sports", className: "logo-extraLarge"},	

		{ src: SaintGobainLogo, alt: "Saint Gobain",className: "logo-big" },
		{ src: EvinoLogo, alt: "Evino" },
		{ src: SrcomLogo, alt: "Srcom" },
		{ src: GrandCruLogo, alt: "Grand Cru", className: "logo-big" },
		{ src: FortalezaLogo, alt: "Fortaleza"},	
		{ src: NeoLogo, alt: "Neo",className: "logo-big" },	
		{ src: Wake, alt: "Wake"},	
		{ src: Unico, alt: "Unico"}
	];

	useEffect(() => {
		const el = brandsTitleRef.current;
		if (!el) return;

		const observer = new IntersectionObserver(
			([entry]) => {
			if (entry.isIntersecting) {
				setShowBrandsTitle(true);
				observer.disconnect();
			}
			},
			{ threshold: 0.3 }
		);

		observer.observe(el);

		return () => observer.disconnect();
	}, []);

	// ✅ título da página (sem rodar a cada render)
	useEffect(() => {
		document.title = "Zest - The full responsa agency";
	}, []);

	// ✅ animação de entrada (slide + blur) no load e ao trocar idioma
	const [isReady, setIsReady] = useState(false);
	useEffect(() => {
		setIsReady(false);
		const r = requestAnimationFrame(() => setIsReady(true));
		return () => cancelAnimationFrame(r);
	}, [i18n.language]);

	// 1) Efeito do título (troca service -> responsibility depois de 2s)
	const [swapDone, setSwapDone] = useState(false);
	useEffect(() => {
		setSwapDone(false);
		const tm = setTimeout(() => setSwapDone(true), 2000);
		return () => clearTimeout(tm);
	}, [i18n.language]);

	/* function scrollToId(e, id) {
		e.preventDefault();
		const el = document.getElementById(id);
		if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
	} */


	const homeJobsItems = useMemo(
		() =>
			i18n.language === "en"
				? ["Communication", "Community Management", "Events"]
				: ["Comunicação", "Gestão de Comunidades", "Eventos"],
		[i18n.language]
	);

	const handleGoToJobs = (e) => {
		e.preventDefault();

		if (scrollToId) return scrollToId(e, "jobs");

		const el = document.getElementById("jobs");
		if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
	};

  return (
    <CssHome>
      <div className={`home ${isReady ? "is-ready" : ""}`}>
        {/* HERO */}
        <section className="hero">
          <div className="hero__inner">
				<div className="hero__left">
					<h1 className="hero__title">
						<span className="tA">{t("home.somosFull")}</span>{" "}
						<span className={`tB ${swapDone ? "is-swap" : ""}`}>
							<span className="service">{t("home.service")}</span>
							<span className="responsibility">{t("home.responsibility")}.</span>
						</span>
					</h1>

					<nav className="heroJobs" aria-label="Serviços">
						{homeJobsItems.map((item) => (
							<a
								key={item}
								href="#jobs"
								className="heroJobs__item"
								onClick={handleGoToJobs}
							>
								{item}
							</a>
						))}
					</nav>

					<a
						href="#jobs"
						className="btnTalk btnTalk--jobs"
						onClick={handleGoToJobs}
					>
						<span>{i18n.language === "en" ? "learn more" : "saiba mais"}</span>
					</a>
				</div>
				<div className="hero__right">
					
					<div className="mediaBox" aria-label="Vídeo/GIF (placeholder)">
						<div className="mediaBox__placeholder">
							<iframe
								src="https://player.vimeo.com/video/1172924635?autoplay=1&muted=1&loop=1&autopause=0"
								title="Vídeo ZEST"
								frameBorder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowFullScreen
							/>
						</div>
					</div>

					{/* geometria decorativa */}
					<div className="geo" aria-hidden="true">
						<img src={Geo} alt="Geo" />
					</div>
				</div>

          </div>
        </section>

        {/* CLIENTS / BRANDS */}
        <section className="brands" id="clients">
          	<h2
				ref={brandsTitleRef}
				className={`brands__title ${showBrandsTitle ? "is-visible" : ""}`}
			>
				{t("home.marcasAcreditam")}
			</h2>

          	<div className="brands__grid">
				{
					brands.map((brand, idx) => (
						<div
							className="brandCard"
							style={{ animationDelay: `${idx * 60}ms` }}
							key={idx}
						>
							<img src={brand.src} alt={brand.alt} title={brand.alt} className={brand.className || ""}/>
						</div>
					))
				}
			</div>
        </section>

        {/* Âncora do contato (no fim da LP você vai colocar a seção real) */}
        <div id="contact" style={{ height: 1 }} />
      </div>
    </CssHome>
  );
};

export default Home;